import { GleapConfig } from '../context/gleap';

const APP_STAGE = import.meta.env.VITE_APP_STAGE || 'dev';

const getGleapEnvironment = (): 'dev' | 'staging' | 'prod' => {
  switch (APP_STAGE) {
    case 'prod':
      return 'prod';
    case 'stg':
      return 'staging';
    default:
      return 'dev';
  }
};

export const GLEAP_TOKEN = 'gBlwx0BP9mOfxGFFOJKEuCwwGVUjdZ3Z';

export const GLEAP_CONFIG: Partial<GleapConfig> = {
  environment: getGleapEnvironment(),
};
